module.exports = __webpack_public_path__ + "img/44.41b5ab26.webp";